
import {
  FAILED_ERROR,
  formatByCountry,
  parsingErrorResponse,
  resolveCountry
} from "@/app/infrastructures/misc/Utils";
import PreviewImagePod from "../../shipment/tracking-stt-cargo/tracking-stt-tab/component/preview-image-pod.vue";
import {
  CourierHistory,
  CourierSttHistory,
  DetailDepositRiwayat,
  PhotosDetailSetorRiwayat
} from "@/domain/entities/CodReconcile";
import { computed, defineComponent, PropType, ref } from "vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import moment from "moment";
import { configDates } from "@/app/infrastructures/misc/common-library/modules/Date";
import PopupDepositDetail from "./popup-deposit-detail.vue";
import { CodReconcileController } from "@/app/ui/controllers/CodReconcileController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";

export default defineComponent({
  name: "PopupBerhasilSetorPaket",
  props: {
    modelValue: { type: Boolean, required: true },
    isSetorUang: { type: Boolean, default: false },
    data: {
      type: Object as PropType<CourierHistory>,
      default: () => new CourierHistory()
    }
  },
  emits: ["update:modelValue", "see-proof"],
  components: { PreviewImagePod, PopupDepositDetail },
  setup(props, { emit }) {
    const prefixCurrency = computed(() =>
      resolveCountry() === "MY" ? "RM" : "Rp"
    );

    const visible = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v)
    });

    const isPreviewPhotos = ref(false);

    const onPreview = () => {
      visible.value = false;
      isPreviewPhotos.value = true;
    };

    const onClosePreview = () => {
      isPreviewPhotos.value = false;
      visible.value = true;
    };

    const isSeeProof = ref(false);
    const selectedData = ref(new DetailDepositRiwayat());
    const onOpenProof = async (item: CourierSttHistory) => {
      if (!item.settlementId) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: "Belum ada riwayat setor dari Driver App",
            image: "circle-error",
            textSuccess: "OK",
            onSubmit: MainAppController.closeMessageModal
          })
        );
        return;
      }

      try {
        MainAppController.showLoading();
        const res = await CodReconcileController.getTaskSettlementCourierDetail(
          item.settlementId
        );

        selectedData.value = new DetailDepositRiwayat({
          ...res,
          totalStt: res.stt.length,
          recipientName: res.personName,
          recipientLocation: res.location,
          paymentMethod: res.paymentMethod,
          photos: res.proofUrls.map(
            (url) =>
              new PhotosDetailSetorRiwayat({
                url
              })
          ),
          stt: res.stt
        });

        visible.value = false;
        isSeeProof.value = true;
      } catch (error) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(
            error,
            "Gagal mengambil data setllement",
            onOpenProof
          )
        );
      } finally {
        MainAppController.closeLoading();
      }
    };

    const onCloseProof = () => {
      isSeeProof.value = false;
      visible.value = false;
    };

    const formattedDate = computed(() => {
      if (!props.data.updatedAt) return "-";

      const timezone =
        AccountController.accountData.account_type_detail.partnerLocation?.city
          ?.timezone;
      const utcOffset = timezone.replace("GMT+", "+0").replace(":", "");
      const tzName = configDates(timezone)["id"];

      const formatDate = moment(props.data.updatedAt)
        .utcOffset(utcOffset)
        .format("DD MMM YYYY, HH.mm");

      return `${formatDate} ${tzName}`;
    });

    return {
      visible,
      isPreviewPhotos,
      formattedDate,
      previewPhotos: computed(() =>
        props.data.photos.map((p: PhotosDetailSetorRiwayat) => p.url)
      ),
      isSeeProof,
      selectedData,
      onOpenProof,
      onCloseProof,
      formatByCountry,
      onPreview,
      onClosePreview,
      prefixCurrency
    };
  }
});
